import {ASSET_LOG_STATUS, CARD_APPLY_STATUS, WITHDRAW_STATUS} from "@/constant/Constant";
import {Tooltip, Typography} from "@mui/material";
import {format} from "date-fns";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

export default function useRenders() {
  const {countries} = useSelector((state) => state.app);
  const {t} = useTranslation();

  const renderCountryName = (country) => {
    if (!country) return "--";
    else {
      const name = countries.filter(
        (el) => el.code?.toUpperCase() === country.toUpperCase()
      );
      return (name && name[0] && name[0].name) || country;
    }
  };

  const renderTooltip = (text) => {
    if (!text) return text;
    return (
      <Tooltip title={text} placement="top" arrow>
        <Typography noWrap>{text}</Typography>
      </Tooltip>
    );
  };

  const renderUpperCase = (text) => {
    return text?.toUpperCase() || "";
  };
  const renderLowerCase = (text) => {
    return text?.toLowerCase() || "";
  };

  const renderDatetime = (datetime) => {
    return datetime && format(datetime, "yyyy-MM-dd HH:mm:ss");
  };
  const renderDate = (datetime) => {
    return datetime && format(datetime, "yyyy-MM-dd");
  };
  const renderMonthDate = (datetime) => {
    return datetime && format(datetime, "MM-dd");
  };

  const renderTransStatus = (status) => {
    const statusList = {
      PENDING: "pending",
      CLEARED: "processed",
      DECLINED: "declined",
      VOID: "cancelled",
    };
    return t(statusList[status]);
  };

  const renderCardStatus = (status) => {
    const statusList = {
      ACTIVE: "activate",
      FROZEN: "freeze",
      EXPIRED: "expired",
      DELETED: "delete",
      BLOCKED: "blocked",
      INACTIVE: "inactive",
    };
    return t(statusList[status]);
  };

  const renderPhysicalCardStatus = (status) => {
    const statusList = {
      CARD_NOT_ORDERED: "no_order", // 未下单
      CARD_IN_PRODUCTION: "card_making", //制卡中
      CARD_ACTIVATED: "activated", // 已激活
      NOT_PHYSICAL_CARD: "inactive_card", // 非实体卡
      CARD_RECEIVED: "received", // 已收到
      CARD_SENT_TO_USER: "sent_user", //已发送用户
      CARD_SHIPPED: "mailed", // 已邮寄
    };
    return t(statusList[status]);
  };

  const renderCardLossStatus = (status) => {
    return t(`loss_status_${status}`);
  };

  const renderCardLockStatus = (status) => {
    return t(`lock_status_${status}`);
  };

  const renderExcelString = (text) => {
    if (!text) return text;
    return `=""${text}""`;
  };

  const renderWithdrawStatus = (status) => {
    let str = "";

    if (status === WITHDRAW_STATUS.Waiting) {
      str = "pending";
    } else if (status === WITHDRAW_STATUS.Pending) {
      str = "pending";

    } else if (status === WITHDRAW_STATUS.Success) {
      str = "complete"

    } else if (status === WITHDRAW_STATUS.Fail) {
      str = "declined";
    } else if (status === WITHDRAW_STATUS.Canceled){
      str = "canceled";
    }

    return t(`withdraw_status_${str}`);
  };

  const renderDepositAccountStatus = (status) => {
    return t(`deposit_account_status_${status}`);
  };

  const renderLongText = (text) => {
    return (
      <Tooltip title={text} arrow>
        <Typography noWrap>{text}</Typography>
      </Tooltip>
    );
  };

  //todo 这个方法没有在用，翻译也没有写
  const renderTxStatus = (status) => {
    return status === 1 ? t("confirmed") : t("unconfirmed");
  };

  const renderAssetLogStatus = (record) => {
    if (record.isRefund == 1) {
      return t('refund');
    }
    switch (record.status) {
      case ASSET_LOG_STATUS.PROCESSING:
        return t('processing')
      case ASSET_LOG_STATUS.SUCCESS:
        return t('completed')
      case ASSET_LOG_STATUS.FAILED:
        return t('failed')
      default:
        return ''
    }
  };

  const renderCardApplyOrderStatus = (status) => {
    switch (status) {
      case CARD_APPLY_STATUS.Pending:
        return t('pending')
      case CARD_APPLY_STATUS.Processing:
        return t('processing')
      case CARD_APPLY_STATUS.Success:
        return t('success')
      case CARD_APPLY_STATUS.Failed:
        return t('failed')
      case CARD_APPLY_STATUS.Cancel:
        return t('cancel')
      case CARD_APPLY_STATUS.Unknown:
        return t('unknown')
      default:
        return ''
    }
  }

  return {
    renderTooltip,
    renderUpperCase,
    renderLowerCase,
    renderDatetime,
    renderDate,
    renderMonthDate,
    renderExcelString,
    renderTransStatus,
    renderWithdrawStatus,
    renderLongText,
    renderTxStatus,
    renderCardStatus,
    renderPhysicalCardStatus,
    renderCardLossStatus,
    renderCardLockStatus,
    renderDepositAccountStatus,
    renderCountryName,
    renderAssetLogStatus,
    renderCardApplyOrderStatus
  };
}
